export default {
  pleaseEnterKeyWords: 'please enter keywords',
  pleaseSelectAstandard: 'please select a standard',
  parentClass: 'parent class',
  classAttribute: 'class properties',
  loading: 'loading',
  noMore: 'no more',
  noData: 'no data: please change the standard or type',
  classSearch: 'class retrieval',
}
